import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const buttonDefaultVariants = {}
const buttonCompoundVariants = [
  {
    "variant": "text",
    "size": "xLarge",
    "css": {
      "root": {
        "padding": "[11px 12px]"
      }
    }
  },
  {
    "variant": "text",
    "size": "large",
    "css": {
      "root": {
        "padding": "[8px 10px]"
      }
    }
  },
  {
    "variant": "text",
    "size": "medium",
    "css": {
      "root": {
        "padding": "[6px 8px]"
      }
    }
  },
  {
    "variant": "text",
    "size": "small",
    "css": {
      "root": {
        "padding": "[6px 6px]"
      }
    }
  },
  {
    "variant": "text",
    "color": "primary",
    "css": {
      "root": {
        "color": "common.10",
        "_hover": {
          "background": "common.a1"
        },
        "_active": {
          "_after": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "text",
    "color": "secondary",
    "css": {
      "root": {
        "color": "success.10",
        "_hover": {
          "background": "success.a1"
        },
        "_active": {
          "_after": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "text",
    "color": "error",
    "css": {
      "root": {
        "color": "error.10",
        "_hover": {
          "background": "error.a1"
        },
        "_active": {
          "_after": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "text",
    "selected": true,
    "color": "primary",
    "css": {
      "root": {
        "background": "success.a2",
        "color": "success.10",
        "_hover": {
          "background": "success.a3"
        },
        "_active": {
          "_after": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "text",
    "selected": true,
    "color": "secondary",
    "css": {
      "root": {
        "background": "success.a2",
        "color": "success.10",
        "_hover": {
          "background": "success.a3"
        },
        "_active": {
          "_after": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "text",
    "selected": true,
    "color": "error",
    "css": {
      "root": {
        "background": "error.a2",
        "color": "error.10",
        "_hover": {
          "background": "error.a3"
        },
        "_active": {
          "_after": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "contained",
    "color": "impact",
    "css": {
      "root": {
        "boxShadow": "0px 0px 0px 4px rgba(197, 80, 237, 0.3), 0px 0px 0px 4px rgba(31, 114, 239, 0.3)",
        "background": "common.gradient.purpleBlue",
        "color": "common.1",
        "transition": "transform 0.2s, box-shadow 0.2s",
        "animation": "animatedGradient 2.8s ease infinite alternate, glowPulse 1.5s ease infinite",
        "_hover": {
          "background": "linear-gradient(0deg, token(colors.common.a3) 0%, token(colors.common.a3) 100%), linear-gradient(135deg, #C550ED 0%, #1F72EF 100%)",
          "boxShadow": "none",
          "transition": "none",
          "animation": "none"
        },
        "_active": {
          "boxShadow": "none",
          "background": "common.gradient.purpleBlue",
          "transition": "none",
          "animation": "none",
          "_after": {
            "opacity": 1
          }
        },
        "_disabled": {
          "boxShadow": "none",
          "transition": "none",
          "animation": "none"
        }
      }
    }
  },
  {
    "variant": "contained",
    "color": "primary",
    "css": {
      "root": {
        "color": "common.1",
        "background": "common.7",
        "_hover": {
          "background": "common.8"
        },
        "_active": {
          "background": "common.9"
        }
      }
    }
  },
  {
    "variant": "contained",
    "color": "secondary",
    "css": {
      "root": {
        "background": "success.7",
        "color": "white.a1300",
        "_hover": {
          "background": "success.8"
        },
        "_active": {
          "_before": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "contained",
    "color": "error",
    "css": {
      "root": {
        "background": "error.7",
        "color": "white.a1300",
        "_hover": {
          "background": "error.8"
        },
        "_disabled": {
          "background": "error.7"
        },
        "_active": {
          "_before": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "contained",
    "selected": true,
    "color": "primary",
    "css": {
      "root": {
        "background": "success.7",
        "color": "common.1",
        "_hover": {
          "background": "success.8"
        },
        "_active": {
          "background": "success.8",
          "_before": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "contained",
    "selected": true,
    "color": "secondary",
    "css": {
      "root": {
        "background": "success.9",
        "color": "white.a1300",
        "_hover": {
          "background": "success.8"
        },
        "_active": {
          "_before": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "contained",
    "selected": true,
    "color": "error",
    "css": {
      "root": {
        "background": "error.9",
        "color": "white.a1300",
        "_hover": {
          "background": "error.8"
        },
        "_active": {
          "_before": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "outlined",
    "color": "primary",
    "css": {
      "root": {
        "border": "1px solid token(colors.common.a2)",
        "color": "common.10",
        "_hover": {
          "border": "1px solid token(colors.common.6)",
          "background": "common.a1"
        },
        "_disabled": {
          "border": "1px solid token(colors.common.a2)"
        },
        "_active": {
          "_after": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "outlined",
    "color": "secondary",
    "css": {
      "root": {
        "border": "1px solid token(colors.success.5)",
        "color": "success.10",
        "_hover": {
          "border": "1px solid token(colors.success.6)",
          "background": "success.a1"
        },
        "_disabled": {
          "border": "1px solid token(colors.success.5)"
        },
        "_active": {
          "_after": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "outlined",
    "color": "error",
    "css": {
      "root": {
        "border": "1px solid token(colors.error.5)",
        "color": "error.10",
        "_hover": {
          "border": "1px solid token(colors.error.6)",
          "background": "error.a1"
        },
        "_disabled": {
          "border": "1px solid token(colors.error.5)"
        },
        "_active": {
          "_after": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "outlined",
    "strong": true,
    "css": {
      "root": {
        "border": "1px solid token(colors.common.7)",
        "color": "common.12",
        "_hover": {
          "border": "1px solid token(colors.common.8)",
          "background": "common.a1"
        },
        "_disabled": {
          "border": "1px solid token(colors.common.7)",
          "background": "common.a1"
        }
      }
    }
  },
  {
    "variant": "outlined",
    "selected": true,
    "color": "primary",
    "css": {
      "root": {
        "background": "success.a3",
        "color": "success.10",
        "borderColor": "success.7",
        "_hover": {
          "background": "success.a1",
          "borderColor": "success.7"
        },
        "_active": {
          "background": "success.a3",
          "_after": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "outlined",
    "selected": true,
    "color": "secondary",
    "css": {
      "root": {
        "background": "success.a3",
        "color": "success.10",
        "borderColor": "success.7",
        "_hover": {
          "background": "success.a1",
          "borderColor": "success.7"
        },
        "_active": {
          "background": "success.a3",
          "_after": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "outlined",
    "selected": true,
    "color": "error",
    "css": {
      "root": {
        "background": "error.a2",
        "color": "error.10",
        "borderColor": "error.7",
        "_hover": {
          "background": "error.a1",
          "borderColor": "error.7"
        },
        "_active": {
          "background": "error.a3",
          "_after": {
            "opacity": 1
          }
        }
      }
    }
  },
  {
    "variant": "outlined",
    "strong": true,
    "selected": true,
    "css": {
      "root": {
        "background": "success.a2",
        "color": "success.10",
        "border": "1px solid token(colors.success.10)",
        "_hover": {
          "background": "success.a3"
        },
        "_active": {
          "_after": {
            "opacity": 1
          }
        }
      }
    }
  }
]

const buttonSlotNames = [
  [
    "root",
    "button__root"
  ],
  [
    "icon",
    "button__icon"
  ],
  [
    "startIcon",
    "button__startIcon"
  ],
  [
    "endIcon",
    "button__endIcon"
  ]
]
const buttonSlotFns = /* @__PURE__ */ buttonSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, buttonDefaultVariants, getSlotCompoundVariant(buttonCompoundVariants, slotName))])

const buttonFn = memo((props = {}) => {
  return Object.fromEntries(buttonSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const buttonVariantKeys = [
  "size",
  "color",
  "variant",
  "strong",
  "selected",
  "fullWidth"
]
const getVariantProps = (variants) => ({ ...buttonDefaultVariants, ...compact(variants) })

export const button = /* @__PURE__ */ Object.assign(buttonFn, {
  __recipe__: false,
  __name__: 'button',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: buttonVariantKeys,
  variantMap: {
  "size": [
    "xLarge",
    "large",
    "medium",
    "small",
    "xSmall"
  ],
  "color": [
    "impact",
    "primary",
    "secondary",
    "error",
    "inherit"
  ],
  "variant": [
    "text",
    "outlined",
    "contained"
  ],
  "strong": [
    "true"
  ],
  "selected": [
    "true"
  ],
  "fullWidth": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, buttonVariantKeys)
  },
  getVariantProps
})